<script setup lang="ts">
import __MACROS_useVModel from "/vue-macros/define-models/use-vmodel";
defineProps({
  data: null,
  multi: { type: Boolean }
});
defineEmits(["update:data", "update:multi"]);
const { multi, data } = __MACROS_useVModel("data", "multi")

function elementClick(item: any) {
  const old = item.open

  if (multi.value) {
    for (const key in data.value)
      data.value[key].open = false
  }

  item.open = !old
}
</script>

<template>
  <div>
    <div v-for="(item, index) in data" :key="index">
      <h2>
        <button
          type="button"
          class="w-full flex items-center justify-between border border-gray-200 p-5 text-left text-black font-medium dark:border-gray-700 hover:bg-gray-100 dark:text-white focus:ring-4 focus:ring-gray-200 dark:hover:bg-gray-700 dark:focus:ring-gray-700"
          @click="elementClick(item)"
        >
          <span>{{ item.label }}</span>
          <div class="flex">
            <div class="mx-2 h-6 w-6 shrink-0" :class="item.open ? ['i-mdi-chevron-down'] : ['i-mdi-chevron-right']" />
          </div>
        </button>
      </h2>
      <Transition>
        <div v-show="item.open">
          <div class="overflow-x-scroll border border-b-0 border-gray-200 p-5 dark:border-gray-700 dark:bg-gray-900">
            <slot :name="`body-${index + 1}`">
            </slot>
          </div>
        </div>
      </Transition>
    </div>
  </div>
</template>
